import React from 'react';
import useIsMobile from '../../helper/useIsMobile';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

const Header = () => {
  const isMobile = useIsMobile();

  if (isMobile === true) return <MobileHeader />;
  if (isMobile === false) return <DesktopHeader />;
  return null;
};

export default Header;
